// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1lK_R","itemTitle":"ClientEmergencyInfo_itemTitle__PLcq3","itemText":"ClientEmergencyInfo_itemText__2Amf1"};